import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import { request, guid, mapStateToProps, mapDispatchToProps } from '../../utils';
import { fetchStartupData } from '../../actions/content';
import { closeSearch } from '../../actions/search';
import { addSongTopQueueDontPlay } from '../../actions/player';
import NewsletterModal from '../NewsletterModal';
import NextSongModal from '../NextSongModal';

class ApplicationHelper extends Component {
  componentDidMount() {
    this.props.dispatch(fetchStartupData()).then((response) => {
      if(response.data.options && response.data.options.track_info) {
        this.props.dispatch(addSongTopQueueDontPlay(response.data.options.track_info));
      }
    });

    // Display newsletter modal
    if(!this.props.config.dont_display_newsletter_modal_again) {
      setTimeout(() => {
        this.props.dispatch({
          type: 'SHOW_NEWSLETTER_MODAL',
          payload: true,
        });
      }, 30 * 1000);
    } else {
      console.log(this.props.config);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);

      this.props.ga.pageview(window.location.pathname + window.location.search);

      this.props.dispatch(closeSearch());
    }
  }

  render() {
    const timeRemaining = this.props.player.time_remaining;
    const nextSong = this.props.player.next_song;

    return (
      <div>
        {this.props.children}
        {
          isBrowser && this.props.config.show_newsletter_modal &&
          !this.props.config.dont_display_newsletter_modal_again ? (
            <NewsletterModal {...this.props} />
          ) : false
        }
        {
          isBrowser && timeRemaining <= 10 && timeRemaining > 0 && this.props.player.show_modal
          && nextSong && nextSong.article_title && nextSong.article_url ? (
            <NextSongModal {...this.props} />
          ) : false
        }
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApplicationHelper));



// WEBPACK FOOTER //
// ./src/components/ApplicationHelper/index.js